import styled from "styled-components";
import colors from "styles/colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 12%;
  gap: 8px;
  box-sizing: border-box;
  border: 1px solid ${colors.gray95};
  align-items: center;
  border-radius: 17px;
  background: ${colors.white};
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
